import { taskStates } from 'pages/Tasks/constants'
import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import type { ResolveActionButtonsProps } from 'redesign/components/templates/task-details-action-buttons/types'
import { getPendingStateButtons } from './get-pending-state-buttons'
import { getTodoStateButtons } from './get-todo-state-buttons'

const getFrontlineActionButtons = (props: ResolveActionButtonsProps): Action[] => {
  const { task } = props

  if (task.statusFe === taskStates.todo) {
    return getTodoStateButtons(props)
  }
  if (task.statusFe === taskStates.pending) {
    return getPendingStateButtons(props)
  }

  return []
}

export default getFrontlineActionButtons
